const isUpdateButtonShownHandler = (id: number | string, data: any) => {
  let isShown;
  if (data && Array.isArray(data) && data.length > 0) {
    data.forEach((item: any, idx: number) => {
      if (item.id === id) {
        if (idx === 0) {
          isShown = true;
        } else {
          isShown = false;
        }
      }
    });
  }
  return isShown;
};

export default isUpdateButtonShownHandler;
